import * as React from 'react';

// tslint:disable:max-line-length
export const GymIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M5 7h6v2H5zM16 7h-1V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9h1V7zM3 2H2a1 1 0 0 0-1 1v4H0v2h1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
    </g>
  </svg>
);
